import { ActiviteitClass } from '@/domain/interface/activiteit/ActiviteitClass';

export class ActiviteitDetailClass extends ActiviteitClass {
  datumIngediend?: string;

  constructor(activiteitDetail?: ActiviteitDetailClass) {
    super(activiteitDetail);
    this.datumIngediend = activiteitDetail?.datumIngediend;
  }
}
